import { DONE_CODES, OTP_RESULT_SUCCESS_MESSAGE, THESE_ARE_YOUR_NEW_BACKUP_CODES } from 'common/constants/auth';
import { Button, Stack } from 'components/ui';
import AuthFormHeader from 'pages/Auth/components/AuthFormHeader';
import AuthPageStack from 'pages/Auth/components/AuthPageStack';
import AuthSuccessPanel from 'pages/Auth/components/AuthSuccessPanel';
import AuthTitleText from 'pages/Auth/components/AuthTitleText';
import BackupCodes from 'pages/Auth/components/BackupCodes';
import { otpActionButtonSx } from 'pages/Auth/components/OTP/OTP.styles';
import type { OtpResultProps } from './OtpResult.props';

const OtpResult = ({
  backupCodes = [],
  isGeneratingBackupCodes = false,
  messageBoxData,
  onBackupCodesAcknowledge,
  onGenerateBackupCodes,
  showActionButtons,
  showHeader = false,
  username,
}: OtpResultProps) => {
  const shouldRenderBackupCodesStep = backupCodes.length > 0;
  const headerTitle = <AuthTitleText lead="Two Factor" tail="Confirmation" />;
  const headerSubtitle = shouldRenderBackupCodesStep && showActionButtons
    ? THESE_ARE_YOUR_NEW_BACKUP_CODES
    : undefined;
  const backupCodesPrimaryActionLabel = showActionButtons ? messageBoxData.nextBtnText : DONE_CODES;
  const actions = showActionButtons ? (
    <Stack direction="row" spacing={2}>
      <Button onClick={messageBoxData.actionBack} variant="text" visualVariant="primaryGhost">
        {messageBoxData.backBtnText}
      </Button>
      <Button
        onClick={messageBoxData.actionNext}
        variant="contained"
        visualVariant="positive"
        sizeVariant="compact"
        sx={otpActionButtonSx}
      >
        {messageBoxData.nextBtnText}
      </Button>
    </Stack>
  ) : undefined;

  return (
    <AuthPageStack>
      {showHeader ? <AuthFormHeader subtitle={headerSubtitle} subtitleVariant="lead" title={headerTitle} /> : null}
      {shouldRenderBackupCodesStep ? (
        <BackupCodes
          backupCodes={backupCodes}
          onGenerateNewCodes={onGenerateBackupCodes}
          onPrimaryAction={onBackupCodesAcknowledge}
          isAuthFlowStep={showActionButtons}
          isGeneratingBackupCodes={isGeneratingBackupCodes}
          primaryActionLabel={backupCodesPrimaryActionLabel}
          username={username}
        />
      ) : (
        <AuthSuccessPanel description={null} mainAction={actions} title={OTP_RESULT_SUCCESS_MESSAGE} />
      )}
    </AuthPageStack>
  );
};

export default OtpResult;
